export default {
  scaleSheetProfiles: state => state.scaleSheetProfiles,
  loading: state => state.loading,
  ticketBooks: state => state.ticketBooks
}
